export default function MiniSignalChart({ value }) {
    return (
        <div className="flex gap-[2px] items-end">
            <div className={`w-[8px] h-[40px] bg-gray-300 rounded-sm ${value >= 5 ? "!bg-[#5b5cff]" : null}`}></div>
            <div className={`w-[8px] h-[30px] bg-gray-300 rounded-sm ${value >= 4 ? "!bg-[#5b5cff]" : null}`}></div>
            <div className={`w-[8px] h-[20px] bg-gray-300 rounded-sm ${value >= 3 ? "!bg-[#5b5cff]" : null}`}></div>
            <div className={`w-[8px] h-[10px] bg-gray-300 rounded-sm ${value >= 2 ? "!bg-[#5b5cff]" : null}`}></div>
            <div className={`w-[8px] h-[5px] bg-gray-300 rounded-sm ${value >= 1 ? "!bg-[#5b5cff]" : null}`}></div>
        </div>
        // <div className="w-[60px] max-w-[60px] min-w-[60px] bg-gray-300 h-[10px] rounded">
        //     <div className="bg-blue-800 h-[10px] rounded" style={{ width: `${(((value / 5) * 100) * 60) / 100}px` }}></div>
        // </div>
    )
}